import React from 'react';
import Input from '../elements/Input';

const Address = ({ formData, handleChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mt-8 mb-2 border-b pb-1 text-gray-800 dark:text-white">Address</h2>
      <div className="grid md:grid-cols-2 gap-6 my-6">
        <Input label="Number/Street" type="text" name="number_street" value={formData.number_street} onChange={handleChange} />
        <Input label="City" type="text" name="city" value={formData.city} onChange={handleChange} />
        <Input label="Country" type="text" name="country" value={formData.country} onChange={handleChange} />
        <Input label="Postal Code" type="text" name="postal_code" value={formData.postal_code} onChange={handleChange} />
        <Input label="Telephone" type="tel" name="telephone" value={formData.telephone} onChange={handleChange} />
        <Input label="Mobile" type="tel" name="mobile" value={formData.mobile} onChange={handleChange} />
      </div>
    </div>
  );
};

export default Address;